export const getTextTagsFromHTML = (htmlFromConclusion: string) => {
  const html = new DOMParser().parseFromString(htmlFromConclusion, 'text/html');
  const paragraphs = html.body.querySelectorAll('body > *');
  const paragraphsList = Array.from(paragraphs);

  return paragraphsList.map((item: Element) => item.outerHTML);
};
